const $inject = ['$rootScope', '$q', 'itinerariesService', 'carSearchService'];

const cartService = function cartService($rootScope, $q, itinerariesService, carSearchService) {
  let service = {
    items: [],
    tickets: [],
    itemCount: 0,
    checkHotelPaymentMethods: false,
    add: add,
    remove: remove,
    addToItinerary: addToItinerary,
    cartContainsMatchedFare: cartContainsMatchedFare,
    getTickets: getTickets,
    getTotal: getTotal,
    getMatchingTicket: getMatchingTicket,
    getMatchingItemTotal: getMatchingItemTotal,
    addTicket: addTicket,
    removeTicket: removeTicket,
    addMultipleTicket: addMultipleTicket,
    clear: clear,
  };

  function getTotal() {
    let total = 0;

    service.items.forEach(function (item) {
      let itemAmount = 0;

      switch (item.type) {
        case 'flight':
          if (item.fare.$state && item.fare.$state.displayMatchedOffset) {
            itemAmount = item.fare.$state.matchedOffset + (item.selectedBundle != null ? item.selectedBundle.price : 0);
          } else {
            itemAmount = item.fare.Amount + (item.selectedBundle != null ? item.selectedBundle.price : 0);
          }

          break;

        case 'rail':
          itemAmount = item.OffsetAmount === undefined ? item.DisplayFare.Amount : item.OffsetAmount;

          break;

        case 'hotel':
          itemAmount = item.rate.TotalAmount;

          break;

        case 'car':
          itemAmount = item.Total;

          break;

        default:
          console.warn('NO CART ITEM TYPE FOUND!');
      }

      if (item.type == 'rail' && itinerariesService.itinerary.IsSinglePnr) {
        total += itemAmount;
      } else {
        total += itemAmount * itinerariesService.totalPaxInCurrentSearch();
      }
    });

    return total;
  }

  function getTickets() {
    return _.map(service.tickets, (ticket) => {
      return _.extend(ticket, {
        TicketAmount: ticket.Value,
      });
    });
  }
  function setAnchoredFlight(item) {
    if (!item || item.type !== 'flight') return;
    let anchoredFlight = item.result.Identifier;
    let searchIdentifier = item.result.SearchIdentifier;
    itinerariesService.itinerary.Search.Flights.forEach((flight) => {
      let searchItem = flight.Searches.find((s) => s.Identifier == searchIdentifier);
      if (searchItem) {
        flight.anchoredFlight = anchoredFlight;
        flight.anchoredTripIdentifier = { TripIdentifier: item.result.TripIdentifier, Fare: travelService.getCleanFare(item) };
      }
    });
  }
  function romoveAnchoredFlight(item) {
    if (!item || item.type !== 'flight') return;
    let searchIdentifier = item.result.SearchIdentifier;
    itinerariesService.itinerary.Search.Flights.forEach((flight) => {
      let searchItem = flight.Searches.find((s) => s.Identifier == searchIdentifier);
      if (searchItem) {
        flight.anchoredFlight = null;
        flight.anchoredTripIdentifier = null;
      }
    });
  }

  function add(newItem) {
    setAnchoredFlight(newItem);
    if (newItem.hasOwnProperty('OptionAutomatic')) {
      if (service.items.length) {
        remove(service.items[0]).then(() => {
          newItem.type = 'car';
          newItem.added = true;
          service.items = [newItem];
        });
      } else {
        newItem.type = 'car';
        newItem.added = true;
        service.items = [newItem];
      }
    }

    if (newItem.hasOwnProperty('hotel')) {
      if (service.items.length) {
        remove(service.items[0]).then(() => {
          newItem.type = 'hotel';
          newItem.room.added = true;
          newItem.rate.added = true;
          service.items = [newItem];
        });
      } else {
        newItem.type = 'hotel';
        newItem.room.added = true;
        newItem.rate.added = true;
        service.items = [newItem];
      }
    }
  }

  function remove(item) {
    const deferred = $q.defer();
    romoveAnchoredFlight(item);
    switch (item.type) {
      case 'rail':
        let removeBoth = false;

        if (service.items.length === 2 && item.OffsetAmount === undefined) {
          removeBoth = true;
        }

        _.remove(service.items, function (cartItem) {
          return cartItem === item;
        });

        item.DisplayFare.isSelected = false;
        item.DisplayFare = item.CheapestFare;
        item.parent.itemInCart = false;
        item.row.selected = false;
        item.addedToCart = false;

        $rootScope.$broadcast('cartService:rail:removed');

        deferred.resolve();

        break;

      case 'flight':
        _.remove(service.items, function (cartItem) {
          return cartItem === item;
        });

        if (removeBoth) {
          remove(service.items[0]);
        }

        item.isRemoving = false;

        $rootScope.$broadcast('cartService:flight:removed');

        deferred.resolve();

        break;

      case 'hotel':
        service.items[0].hotel.added = false;
        service.items[0].room.added = false;
        service.items[0].rate.added = false;

        delete service.items[0].PolicyCode;
        delete service.items[0].PolicyTitle;
        delete service.items[0].PolicyComments;
        delete service.items[0].LostSavingsAmount;

        item.isRemoving = false;

        clear();

        deferred.resolve();

        break;

      case 'car':
        service.items[0].added = false;

        delete service.items[0].PolicyCode;
        delete service.items[0].PolicyTitle;
        delete service.items[0].PolicyComments;
        delete service.items[0].LostSavingsAmount;
        delete service.items[0].Delivery;
        delete service.items[0].Collection;

        item.isRemoving = false;

        clear();

        deferred.resolve();

        break;

      default:
        console.warn('NO CART ITEM TYPE FOUND!');

        deferred.reject();
    }

    return deferred.promise;
  }

  function addToItinerary(type) {
    let cleanedItems = {};
    switch (type) {
      case 'Rails':
        cleanedItems = service.items.map((item) => {
          let railItem = item;
          let policy = null;

          if (item.DisplayFare) {
            railItem = item.DisplayFare;
          }

          if (item.fareOverride) {
            railItem = item.fareOverride;
          }

          if (item.DisplayFare && item.DisplayFare.selectedAdditional) {
            railItem = item.DisplayFare.selectedAdditional;
          }

          if (item.PolicyCode || (item.PolicyViolations && item.PolicyViolations.length > 0)) {
            policy = {
              Code: item.PolicyCode,
              Title: item.PolicyTitle,
              Comments: item.PolicyComments,
              PolicyViolations: item.PolicyViolations,
            };
          }

          return {
            Carrier: item.row.Carrier,
            RailNumber: item.row.RailNumber,
            Departure: {
              Code: item.row.OriginLocationCode,
              Location: item.row.OriginLocation,
              Date: item.row.DepartureDateTimeOffset,
              City: item.row.OriginCity,
            },
            Arrival: {
              Code: item.row.DestinationLocationCode,
              Location: item.row.DestinationLocation,
              Date: item.row.ArrivalDateTimeOffset,
              City: item.row.DestinationCity,
            },
            Detail: {
              Codes: railItem.ResBookDesignCode.join(),
              Rates: railItem.Code.join(),
              RailCardCode: railItem.RailCardCode,
            },
            SearchIdentifier: item.row.SearchIdentifier,
            Policy: policy,
          };
        });
        break;

      case 'Flights':
        cleanedItems = service.items.map((item) => {
          let policy = null;
          let timePolicy = null;
          let lostSavingsAmount = null;
          let flyAmericaActComplianceStatus = null;

          if (item.fare.PolicyException) {
            policy = {
              Code: item.fare.PolicyException.PolicyCode,
              Title: item.fare.PolicyException.PolicyTitle,
              Comments: item.fare.PolicyException.PolicyComments,
              PolicyViolations: item.fare.PolicyException.PolicyViolations,
            };

            timePolicy = {
              Code: item.fare.PolicyException.OutOfTimePolicyCode,
              Title: item.fare.PolicyException.OutOfTimePolicyTitle,
              LeadTimeForInPolicyBooking: item.fare.PolicyException.LeadTimeForInPolicyBooking,
            };

            flyAmericaActComplianceStatus = {
              FlyAmericaActBreakPolicyReason: item.fare.PolicyException.FlyAmericaPolicyTitle,
              FlyAmericaActBreakPolicyReasonCode: item.fare.PolicyException.FlyAmericaPolicyCode,
              FlyAmericaActComplianceExceptionReason: item.fare.PolicyException.FlyAmericaActComplianceExceptionReason,
              FlyAmericaActComplianceType: item.fare.PolicyException.FlyAmericaActComplianceType,
            };
            lostSavingsAmount = item.fare.PolicyException.LostSavingsAmount;
          }

          return {
            Carrier: item.result.Carrier,
            FlightNumber: item.result.TripNumber,
            Departure: {
              Code: item.result.OriginLocationCode,
              Location: item.result.OriginLocation,
              City: item.result.OriginCity,
              Date: item.result.DepartureDateTimeOffset,
            },
            Arrival: {
              Code: item.result.DestinationLocationCode,
              Location: item.result.DestinationLocation,
              City: item.result.DestinationCity,
              Date: item.result.ArrivalDateTimeOffset,
            },
            Detail: {
              Codes: item.fare.ResBookDesignCode.join(),
              Rates: item.fare.Code.join(),
              GdsProvider: item.fare.GdsProvider,
            },
            SearchIdentifier: item.result.SearchIdentifier,
            LostSavingsAmount: lostSavingsAmount,
            Policy: policy,
            TimePolicy: timePolicy,
            FlyAmericaActComplianceStatus: flyAmericaActComplianceStatus,
          };
        });
        break;

      case 'Cars':
        cleanedItems = service.items.map((C) => {
          let policy = {
            Code: C.PolicyCode,
            Title: C.PolicyTitle,
            Comments: C.PolicyComments,
            PolicyViolations: C.PolicyViolations,
          };
          let specialRequests = null;
          let lostSavingsAmount = null;

          if (C.specialRequests) {
            specialRequests = C.specialRequests;
          }

          if (C.LostSavingsAmount) {
            lostSavingsAmount = C.LostSavingsAmount;
          }

          return {
            Supplier: {
              Code: C.Vendor.Code,
              Title: C.Vendor.Title,
            },
            Vehicle: {
              Code: C.Code,
              Class: C.Class,
              Title: C.Title,
              Category: C.Category,
            },
            RateCode: C.RateCode,
            CurrencyCode: C.CurrencyCode,
            PickUp: {
              Date: carSearchService.results.PickUpDate,
              Code: C.PickupLocationCode,
              Location: C.PickupLocation,
            },
            DropOff: {
              Date: carSearchService.results.DropOffDate,
              Code: C.DropOffLocationCode,
              Location: C.DropOffLocation,
            },
            DeliveryAddress: C.DeliveryAddress,
            CollectionAddress: C.CollectionAddress,
            SearchIdentifier: carSearchService.results.SearchIdentifier,
            Amount: C.Total,
            TaxAmount: 0.0,
            SpecialRequests: specialRequests,
            LostSavingsAmount: lostSavingsAmount,
            Policy: policy,
          };
        });

        break;

      case 'Hotels':
        cleanedItems = service.items.map((item) => {
          let currentSearch = itinerariesService.getCurrentSearch();
          let policy = {};
          let paymentNarrative = null;
          let specialRequirements = null;
          let lostSavingsAmount = null;

          if (item.PolicyCode) {
            policy = {
              Code: item.PolicyCode,
              Title: item.PolicyTitle,
              Comments: item.PolicyComments,
            };
          }
          if (item.PolicyViolations) policy.PolicyViolations = item.PolicyViolations;

          if (item.HotelPaymentNarrative) {
            paymentNarrative = {
              Code: item.HotelPaymentNarrative.PaymentCode,
              Title: item.HotelPaymentNarrative.PaymentNarrative,
              Description: item.HotelPaymentNarrative.PaymentInstructions,
              ServiceCode: item.HotelPaymentNarrative.ServiceFeeCode,
            };
          }

          if (item.specialRequirements) {
            specialRequirements = item.specialRequirements;
          }

          if (item.LostSavingsAmount) {
            lostSavingsAmount = item.LostSavingsAmount;
          }

          return {
            DateFrom: item.dateFrom,
            DateTo: item.dateTo,
            HotelCode: item.room.HotelCode,
            HotelName: item.hotel.HotelName,
            ChainCode: item.hotel.ChainCode,
            RateCode: item.rate.RateCode,
            RoomName: item.room.RoomName,
            Identification: item.room.Identification,
            Location: {
              Code: item.hotel.HotelCityCode,
            },
            SpecialRequirements: specialRequirements,
            BookingPaymentTypeCode: item.rate.BookingPaymentTypeCode,
            SearchIdentifier: currentSearch.Identifier,
            Amount: item.rate.TotalAmount,
            TaxAmount: item.rate.TaxAmount,
            LostSavingsAmount: lostSavingsAmount,
            Policy: Object.keys(policy).length ? policy : null,
            PaymentNarrative: paymentNarrative,
            DepositPolicy: item.rate.DepositPolicy,
            BookingPaymentType: item.rate.BookingPaymentType,
            HotelRateDetails: item.rate.HotelRateDetails,
          };
        });

        break;

      default:
        console.warn('NO TYPE FOUND!');
    }

    return {
      cleanedItems: cleanedItems,
      type: type,
    };
  }

  function cartContainsMatchedFare(matchedFares) {
    return containsMatchedFare(service.items, matchedFares);
  }

  function containsMatchedFare(fares, matchedFares) {
    return _.some(fares, (cartItem) => {
      return _.some(matchedFares, (matchedFare) => {
        return matchedFare.Identifier === cartItem.fare.Identifier;
      });
    });
  }

  function getMatchingTicket(ticket) {
    return _.find(
      service.tickets,
      (selectedTicket) => {
        return ticket.Carrier === selectedTicket.Carrier && ticket.PassengerIdentifier === selectedTicket.PassengerIdentifier;
      },
      0
    );
  }

  function getMatchingItemTotal(ticket) {
    return _.reduce(
      service.items,
      (total, selectedItem) => {
        const sameCarrier = ticket.Carrier === selectedItem.result.Carrier;

        return total + (sameCarrier ? selectedItem.fare.Amount : 0);
      },
      0
    );
  }

  function addTicket(ticket) {
    if (ticket.isSelected) {
      return false;
    }
    ticket.isSelected = true;
    deselectOtherTickets(ticket);
    service.tickets.push(ticket);
  }

  function addMultipleTicket(ticket, remove) {
    if (remove) {
      ticket.isSelected = false;
      removeTicket(ticket);
    } else {
      ticket.isSelected = true;
      service.tickets.push(ticket);
    }
  }

  function removeTicket(ticket) {
    ticket.isSelected = false;

    service.tickets = _.reject(service.tickets, (selectedTicket) => {
      return selectedTicket === ticket;
    });
  }

  function deselectOtherTickets(selectedTicket) {
    for (let i = 0; i < service.tickets.length; i++) {
      let otherTicket = service.tickets[i];
      if (otherTicket !== selectedTicket) {
        otherTicket.isSelected = false;
        service.tickets.splice(i, 1);
      }
    }
  }

  function clear() {
    service.items = [];
    service.tickets = [];
  }

  return service;
};

cartService.$inject = $inject;

export default cartService;



// WEBPACK FOOTER //
// ./src/services/cartService.js